import { useMutation, useQueryClient } from '@tanstack/react-query';

import envVars from '../../../constants/envVars';
import { useSetNotification } from '../../../context/Notification';
import useRequest from '../../../hooks/useRequest';
import { UnassignCareManagersPayload, UnassignCareManagersResponse } from '../types';
import { ORGANIZATION_MEMBER_LIST_KEY } from './constants';

const useUnassignCareManagers = (onSuccess?: () => void) => {
    const req = useRequest();
    const queryClient = useQueryClient();
    const setNotification = useSetNotification();

    const request = ({ payload }: { payload: UnassignCareManagersPayload }) => {
        return req<UnassignCareManagersResponse>({
            url: `${envVars.API_RTM_HOSTNAME}enterprise/care-manager/unassign/`,
            method: 'POST',
            body: JSON.stringify(payload)
        });
    };

    return useMutation({
        mutationFn: request,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [ORGANIZATION_MEMBER_LIST_KEY] });
            setNotification({ message: 'Care manager unassigned successfully' });
            onSuccess && onSuccess();
        },
        onError: (error?: { errors: string[] }) => {
            return error?.errors[0] || 'An error occurred while unassigning care managers';
        }
    });
};

export default useUnassignCareManagers;
